var _path, _path2, _path3;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgC4(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 2499,
    height: 2500,
    viewBox: "0 0 213.281 213.342",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M72.875 67.856l66.029-65.797c2.762-2.752 7.271-2.744 10.023.017l62.295 62.514c2.754 2.761 2.744 7.272-.018 10.024l-66.027 65.798-72.302-72.556zm59.165-11.675c6.934-6.909 18.154-6.889 25.062.043s6.889 18.154-.043 25.062c-6.934 6.908-18.154 6.888-25.062-.044-6.908-6.931-6.889-18.153.043-25.061z",
    fillRule: "evenodd",
    clipRule: "evenodd",
    fill: "#e61e29"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M82.162 131.657c6.933-6.909 18.153-6.891 25.062.043 6.909 6.932 6.889 18.153-.044 25.062-6.932 6.908-18.153 6.888-25.062-.045-6.909-6.931-6.889-18.153.044-25.06zm-51.879.16c6.933-6.909 18.153-6.89 25.062.043 6.908 6.932 6.889 18.153-.044 25.062-6.932 6.908-18.153 6.888-25.062-.045-6.908-6.931-6.888-18.152.044-25.06zm-28.206 6.592L68.104 72.61l72.303 72.556-66.028 65.798c-2.762 2.752-7.272 2.744-10.025-.018L2.059 148.433c-2.752-2.762-2.744-7.272.018-10.024z",
    fillRule: "evenodd",
    clipRule: "evenodd",
    fill: "#0074ad"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M97.332 213.342v-8.856H93.96v-1.546h8.499v1.546h-3.393v8.856h-1.734zm6.29 0V202.94h2.553l2.627 8.307 2.539-8.307h2.506v10.402h-1.586v-8.729l-2.68 8.729h-1.568l-2.796-8.856v8.856h-1.595z",
    fill: "#0074ad"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgC4);
export default __webpack_public_path__ + "static/media/c4.f530d6142fb242f43fbefe9f49af214b.svg";
export { ForwardRef as ReactComponent };